import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSettings } from "../../contexts/Settings";
import { Button } from "../Button";
import { SettingsModal } from "../SettingsModal";
import { faGear } from "@fortawesome/free-solid-svg-icons";
import { PlaybackRateModal } from "../SettingsModal/PlaybackRateModal";
import { ResolutionsModal } from "../SettingsModal/ResolutionsModal";

export const SettingsButton = () => {
  const { showBaseModal, setShowBaseModal } = useSettings();

  const onClick = () => {
    setShowBaseModal(!showBaseModal);
  };

  const style = {
    height: 26,
    transition: "transform 0.3s",
    transform: `rotate(${showBaseModal ? 90 : 0}deg)`,
  };

  return (
    <>
      <PlaybackRateModal />
      <ResolutionsModal />
      <SettingsModal />
      <Button onClick={onClick}>
        <FontAwesomeIcon style={style} icon={faGear} />
      </Button>
    </>
  );
};
